import { render, staticRenderFns } from "./OInput.vue?vue&type=template&id=71b4e8d5&scoped=true&"
import script from "./OInput.vue?vue&type=script&lang=js&"
export * from "./OInput.vue?vue&type=script&lang=js&"
import style0 from "./OInput.vue?vue&type=style&index=0&id=71b4e8d5&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b4e8d5",
  null
  
)

export default component.exports